import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import searchReducer from 'modules/global/reducers/simpleSearchReducer';
import * as actionTypes from 'modules/groups/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import assigning from './assigning';

/**
 * @typedef {{
 *   selectedGroupId: string,
 *   details: { creating: boolean, updating: boolean },
 *   groupConfig: {
 *     ready: boolean,
 *     assigning: boolean,
 *     initialized: boolean,
 *   },
 *   select: import("modules/global/reducers/simpleSearchReducer").SimpleSearchReducer,
 *   byExtension: Record<import("modules/global/typing/enums/extensions.enum").ExtensionEnum, string[]>,
 *   assigning: import("./assigning").GroupAssigningUIReducer,
 * }} GroupUIReducer
 */

export default combineReducers({
  selectedGroupId: createReducer('', {
    [actionTypes.SELECT_GROUP]: (_, { payload }) => payload.groupId,
  }),
  details: combineReducers({
    creating: loading(actionTypes.CREATE_GROUP_REQUEST),
    updating: loading(actionTypes.UPDATE_GROUP_REQUEST),
  }),
  groupConfig: combineReducers({
    initialized: createReducer(false, {
      [actionTypes.INITIALIZED_GROUP_TAB]: (_, { payload }) => payload,
      [LOCATION_CHANGE]: () => false,
    }),
    ready: createReducer(false, {
      [actionTypes.GROUP_CONFIG_IS_READY]: (_, { payload }) => payload,
    }),
    assigning: loading(actionTypes.ASSIGNMENT_GROUP_TO_DEALERS_REQUEST),
  }),
  select: searchReducer(actionTypes.FETCH_GROUPS_SELECT_REQUEST, {
    ids: {
      [actionTypes.CREATE_GROUP_SUCCESS]: (state, { payload: { id } }) => [id, ...state],
    },
  }),
  byExtension: createReducer(
    {},
    {
      [actionTypes.FETCH_GROUPS_BY_EXTENSION_SUCCESS]: (state, { payload, meta }) => ({
        ...state,
        [meta.extension]: payload.content.map(({ id }) => id),
      }),
    }
  ),
  assigning,
  groupManagement: combineReducers({
    ready: createReducer(false, {
      [LOCATION_CHANGE]: () => false,
      [actionTypes.GROUP_MANAGEMENT_IS_READY]: (state, { payload }) => payload,
    })
  })
});
